import './styles/whitelist.css'
import WHITELISTS from './whitelists.json'

// Check whitelist status
const checkWhitelistStatus = (userAddress) => {
  const lowerUserAddress = userAddress.toLowerCase();
  
  // Check GTD list first
  const isInGTD = WHITELISTS.GTD.some(address => 
    address.toLowerCase() === lowerUserAddress
  );
  
  if (isInGTD) {
    return { inList: true, listType: "GTD" };
  }
  
  // Check Whitelist
  const isInWhitelist = WHITELISTS.Whitelist.some(address => 
    address.toLowerCase() === lowerUserAddress
  );
  
  if (isInWhitelist) {
    return { inList: true, listType: "Whitelist" };
  }
  
  return { inList: false, listType: null };
};

// Display result on page
const displayResult = (message, type = 'info') => {
  const resultElement = document.getElementById('check-result');
  resultElement.textContent = message;
  resultElement.className = `result-display ${type}`;
};

// Validate Ethereum address
const isValidAddress = (address) => {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
};

// Update input styling based on validation
const updateInputValidation = (input, address) => {
  input.classList.remove('valid', 'invalid');
  
  if (!address || address.length === 0) {
    // Empty input - no styling
    return;
  }
  
  if (address.length < 3) {
    // Too short to validate
    return;
  }
  
  if (isValidAddress(address)) {
    input.classList.add('valid');
  } else {
    input.classList.add('invalid');
  }
};

// Check function (called by Check button)
const checkFunction = async () => {
  const addressInput = document.getElementById('address-input');
  const address = addressInput?.value?.trim();
  
  if (!address) {
    displayResult("Please enter an address!", "error");
    return;
  }
  
  if (!isValidAddress(address)) {
    displayResult("Please enter a valid Ethereum address!", "error");
    return;
  }
  
  const result = checkWhitelistStatus(address);
  
  if (result.inList) {
    displayResult(`✅ Your address is in the ${result.listType}!`, "success");
  } else {
    displayResult("❌ Your address is not in any whitelist.", "error");
  }
};

// DOM Event Listeners
document.addEventListener('DOMContentLoaded', () => {
  // Show initial message
  displayResult("👆 Enter your address and click 'Check' to verify if it's in the whitelist", "info");
  
  // Check button
  const checkBtn = document.getElementById('check-btn');
  checkBtn?.addEventListener('click', checkFunction);
  
  // Address input event listeners
  const addressInput = document.getElementById('address-input');
  
  // Enter key on address input
  addressInput?.addEventListener('keypress', (event) => {
    if (event.key === 'Enter') {
      checkFunction();
    }
  });
  
  // Real-time validation on input
  addressInput?.addEventListener('input', (event) => {
    const address = event.target.value.trim();
    updateInputValidation(addressInput, address);
  });
  
  // Validation on paste
  addressInput?.addEventListener('paste', (event) => {
    setTimeout(() => {
      const address = event.target.value.trim();
      updateInputValidation(addressInput, address);
    }, 0);
  });
  
  // Clear validation classes on focus
  addressInput?.addEventListener('focus', () => {
    if (addressInput.value.trim() === '') {
      addressInput.classList.remove('valid', 'invalid');
    }
  });
});